import type { en } from "./en";

/** Russian strings; the type forces every English key to be translated. */
export const ru: Record<keyof typeof en, string> = {
  // App chrome
  "nav.devices": "Устройства",
  "nav.triggers": "Триггеры",
  "nav.analyzes": "Анализ",
  "nav.agentApk": "APK агента",
  "nav.settings": "Настройки",
  "app.signOut": "Выйти",
  "lang.label": "Язык",

  // Login
  "login.email": "Email",
  "login.password": "Пароль",
  "login.signIn": "Войти",
  "login.signingIn": "Входим…",
  "login.failed": "Не удалось войти",
  "login.expired": "Доступ закончился {date}. Свяжитесь с нами, чтобы продлить.",
  "login.expiredNoDate": "Доступ закончился. Свяжитесь с нами, чтобы продлить.",
  "login.suspended": "Аккаунт приостановлен. Свяжитесь с нами для восстановления доступа.",
  "login.consoleBlocked":
    "Доступ к панели закрыт поставщиком. Телефоны продолжают работать.",
  "login.tooManyAttempts": "Слишком много попыток входа. Повторите через несколько минут.",
  "login.handoffExpired":
    "Эта ссылка поддержки уже использована или устарела. Откройте панель клиента из админ-консоли заново.",

  // Панель клиента, открытая из нашей консоли
  "support.session": "Сеанс поддержки",
  "support.end": "Выйти",

  // Аккаунт
  "account.until": "Доступ до {date}",
  "account.unlimited": "Без срока",
  "account.endsInDays": "Доступ заканчивается через {n} дн.",
  "account.endsToday": "Доступ заканчивается сегодня",
  "account.ended": "Доступ закончился {date}",
  "account.suspended": "Аккаунт приостановлен",
  "account.plan": "Ваш тариф",
  "account.devicesUsed": "Телефонов используется",
  "account.deviceCap": "Лимит телефонов",
  "account.noCap": "Без лимита",

  // APK агента
  "apk.title": "APK агента",
  "apk.intro":
    "Соберите установщик для своих телефонов. Каждая сборка несёт ваш ключ подключения, поэтому телефон появится в разделе «Телефоны» сам.",
  "apk.generate": "Собрать APK",
  "apk.generating": "Ставим в очередь…",
  "apk.label": "Метка партии (необязательно)",
  "apk.labelHint": "Станет тегом на каждом телефоне из этой сборки.",
  "apk.key": "Ключ подключения",
  "apk.newKey": "Создать новый ключ",
  "apk.keyLegacy": "{name} — нельзя использовать повторно",
  "apk.keyUnavailable":
    "Этот ключ больше нельзя зашить в APK — обычно потому, что он создан до того, как ключи стало можно использовать повторно. Выберите другой ключ или оставьте поле на «Создать новый ключ».",
  "apk.cap": "Лимит телефонов для ключа (необязательно)",
  "apk.batchLabel": "Партия",
  "devices.noneDefined": "Наборов проверок нет",
  "apk.builds": "Сборки",
  "apk.created": "Создана",
  "apk.version": "Агент",
  "apk.status": "Статус",
  "apk.size": "Размер",
  "apk.download": "Скачать",
  "apk.checksum": "SHA-256",
  "apk.noBuilds": "Сборок пока нет.",
  "apk.noTemplate":
    "Релиз агента пока не опубликован. Мы скоро его выложим — напишите нам, если это надолго.",
  "apk.keys": "Ключи подключения",
  "apk.keyName": "Название",
  "apk.keyDevices": "Телефонов подключено",
  "apk.keyLastUsed": "Последнее использование",
  "apk.revoke": "Отозвать",
  "apk.revoked": "Отозван",
  "apk.noKeys": "Ключей пока нет.",
  "apk.keyShownOnce": "Скопируйте ключ сейчас — он больше не покажется.",
  "apk.install": "Установка на телефон",
  "apk.install1": "Скопируйте APK на телефон и откройте. Разрешите установку из этого источника.",
  "apk.install2": "Откройте QA Agent и выдайте разрешение «Специальные возможности».",
  "apk.install3": "Отключите оптимизацию батареи для QA Agent, чтобы связь не рвалась.",
  "apk.install4": "Телефон появится в разделе «Телефоны» в течение минуты.",
  "apk.design": "Дизайн экрана",
  "apk.builtInScreen": "Встроенный экран",
  "apk.designLink": "Оформить экран",
  "apk.designColumn": "Экран",
  "apk.designUnsupported":
    "Текущая версия агента ({version}) пока не умеет показывать свой экран. Напишите нам — нужна 0.4.0 или новее.",
  "apk.install2Designed":
    "Откройте QA Agent, нажмите \u00ab{button}\u00bb и дайте доступ к спец. возможностям.",
  "apk.modulesColumn": "Модули",
  "apk.designUses": "Экран \u00ab{design}\u00bb использует: {uses}",
  "apk.usesModule": "{module} ({actions} действ., {values} знач., {blocks} блок.)",
  "apk.modulesInBuild": "Модули в этой сборке: {modules}.",
  "apk.modulesNone": "нет",
  "apk.modulesLink": "Модули",
  "apk.moduleUnsupported":
    "Текущий релиз агента ({version}) вышел раньше модуля {module}. Он появится в сборке, как только мы выложим более новый релиз.",
  "apk.designModuleDisabled":
    "\u00ab{design}\u00bb использует {modules}, а модуль выключен — на телефоне кнопка ничего не сделает. Включите его или выберите другой экран:",
  "apk.copy": "Копировать",
  "apk.copied": "Скопировано",

  // Сборка на этом компьютере, в десктопном приложении (DESKTOP §7)
  "apk.buildHere": "Собрать на этом компьютере",
  "apk.buildHereBusy": "Собираем…",
  "apk.buildOnServer": "Собрать на сервере",
  "apk.buildHereHint":
    "Собранный здесь APK подписан ключом этого компьютера \u2014 поэтому телефон с агентом от серверной сборки придётся один раз удалить, прежде чем ставить этот. Сразу после установки он подключится сам.",
  "apk.stageKey": "Создаём ключ подписи\u2026",
  "apk.stageDownload": "Скачиваем агента\u2026",
  "apk.stageStamp": "Вшиваем ваши настройки\u2026",
  "apk.stageSign": "Подписываем\u2026",
  "apk.stageSave": "Сохраняем\u2026",
  "apk.savedTo": "Сохранено: {path}",
  "apk.buildCancelled": "Отменено до сохранения.",
  "apk.builtOnAComputer": "Собрано на компьютере",
  "apk.signingKey": "Ключ подписи",
  "apk.signingKeyIntro":
    "APK, собранные на этом компьютере, подписаны этим ключом. Сделайте резервную копию: без неё телефон не сможет обновиться поверх и потребует переустановки.",
  "apk.signingKeyNone": "Будет создан при первой сборке на этом компьютере.",
  "apk.signingKeyFingerprint": "Отпечаток",
  "apk.signingKeyCreated": "Создан",
  "apk.keyExportPassword": "Пароль для резервной копии",
  "apk.exportKey": "Выгрузить\u2026",
  "apk.keyImportPassword": "Пароль резервной копии",
  "apk.importKey": "Загрузить\u2026",
  "apk.keyImportConfirm":
    "Заменить ключ подписи на этом компьютере? Телефоны с APK, подписанным текущим ключом, придётся переустановить.",
  "apk.keyExported": "Резервная копия сохранена: {path}",
  "apk.keyImported": "Ключ заменён. Новый отпечаток: {fingerprint}",

  // Common
  "loading": "Загружаем {what}…",
  "loading.devices": "устройства",
  "loading.triggers": "триггеры",
  "loading.analyzes": "наборы анализа",
  "loading.settings": "настройки",
  "loading.device": "устройство",
  "time.secondsAgo": "{n} с назад",
  "time.minutesAgo": "{n} мин назад",
  "time.hoursAgo": "{n} ч назад",
  "time.daysAgo": "{n} дн назад",

  // Statuses
  "status.online": "онлайн",
  "status.busy": "занят",
  "status.needs_attention": "требует внимания",
  "status.offline": "офлайн",
  "status.quarantined": "карантин",
  "status.queued": "в очереди",
  "status.allocating": "выделяется",
  "status.running": "выполняется",
  "status.passed": "пройден",
  "status.failed": "провален",
  "status.cancelled": "отменён",
  "status.error": "ошибка",
  "status.pending": "ожидает",
  "status.building": "собирается",
  "status.ready": "готово",
  "status.local": "на компьютере",
  "status.skipped": "пропущен",

  // Analyze kinds
  "kind.language": "Язык телефона",
  "kind.app": "Установлено приложение",
  "kind.country": "Страна",
  "kindShort.language": "язык",
  "kindShort.app": "приложение",
  "kindShort.country": "страна",

  // Devices
  "devices.searchPlaceholder": "Поиск по имени, модели, тегу, языку, стране…",
  "devices.searchAria": "Поиск устройств",
  "devices.clearSearch": "Очистить поиск",
  "devices.filterByStatus": "Фильтр по статусу",
  "devices.all": "Все",
  "devices.th.device": "Устройство",
  "devices.th.status": "Статус",
  "devices.th.permissions": "Разрешения",
  "devices.th.analyzes": "Анализ",
  "devices.manageAnalyzes": "Управление наборами анализа",
  "devices.th.locale": "Локаль",
  "devices.th.added": "Добавлен",
  "devices.notReportedYet": "Ни один heartbeat ещё не приносил отчёт о разрешениях",
  "devices.notReported": "пока не сообщалось",
  "devices.unnamed": "без названия",
  "devices.noCriteria": "нет условий",
  "devices.enrolled": "Зарегистрирован {at}",
  "devices.new": "новый",
  "devices.lastHeartbeat": "Последний heartbeat",
  "devices.expand": "Показать подробности: {name}",
  "devices.collapse": "Скрыть подробности: {name}",
  "devices.openPanel": "Открыть панель телефона",
  "devices.detail.phone": "Телефон",
  "devices.detail.model": "Модель",
  "devices.detail.os": "ОС",
  "devices.detail.screen": "Экран",
  "devices.detail.battery": "Батарея",
  "devices.detail.agent": "Агент",
  "devices.detail.sim": "SIM",
  "devices.detail.locale": "Локаль",
  "devices.detail.tags": "Теги",
  "devices.detail.state": "Состояние",
  "devices.detail.enrolled": "Подключён",
  "devices.thisFilter": "этому фильтру",
  "devices.noMatch": "Нет устройств, соответствующих {what}.",
  "devices.clearFilters": "Сбросить фильтры",
  "devices.empty": "Пока нет зарегистрированных устройств.",
  "devices.showing": "Показано устройств: {shown} из {total}",
  "devices.filtersOn": "применены фильтры",

  // Permission chips (Devices)
  "perm.granted": "Выдано",
  "perm.notGranted": "Не выдано",
  "perm.accessibility": "Спец. возможности",
  "perm.accessibility.why": "Основной канал управления: жесты, ввод текста и снятие дерева.",
  "perm.screen_capture": "Захват экрана",
  "perm.screen_capture.why":
    "Живая картинка и записи. На Android 11+ достаточно спецвозможностей; на Android 10 и старше нужно один раз разрешить захват экрана на телефоне.",
  "perm.ime": "Клавиатура",
  "perm.ime.why": "Собственная клавиатура агента — нужна для паролей и key events.",
  "perm.notifications": "Уведомления",
  "perm.notifications.why": "Скрывает уведомление foreground-сервиса; Android убьёт агента раньше.",

  // Triggers
  "triggers.title": "Триггеры",
  "triggers.new": "Новый триггер",
  "triggers.introA":
    "Триггер позволяет телефону записывать самостоятельно: агент следит за условием и захватывает окно, когда оно срабатывает. Активируйте триггер из",
  "triggers.devicePanelLink": "панели устройства",
  "triggers.th.name": "Название",
  "triggers.th.condition": "Условие",
  "triggers.th.recording": "Запись",
  "triggers.th.armedOn": "Активен на",
  "triggers.th.actions": "Действия",
  "triggers.condApp": "Открывается приложение",
  "triggers.condText": "Появляется текст",
  "triggers.notArmed": "Не активен",
  "triggers.edit": "Изменить",
  "triggers.delete": "Удалить",
  "triggers.deleteConfirm": "Удалить триггер {name}?",
  "triggers.deleteArmedOne": "Он активен на одном телефоне — тот перестанет следить.",
  "triggers.deleteArmedMany": "Он активен на {n} телефонах — они перестанут следить.",
  "triggers.deleteGone": "Действие необратимо.",
  "triggers.deleteTrigger": "Удалить триггер",
  "triggers.keepIt": "Оставить",
  "triggers.empty": "Триггеров пока нет.",
  "triggers.createFirst": "Создать первый триггер",
  "triggers.cancel": "Отмена",
  "triggers.chipAria": "{name}, {status}",
  "triggers.chipTitle": "{name} — {status}. Открыть панель устройства.",
  "triggers.armedNoteOne": "Активен на одном телефоне: при сохранении новое условие уйдёт ему сразу.",
  "triggers.armedNoteMany": "Активен на {n} телефонах: при сохранение новое условие уйдёт им сразу.",
  "triggers.armedNoteNone": "Пока не активен ни на одном телефоне.",
  "triggers.name": "Название",
  "triggers.nameHintEdit": "Название триггера изменить нельзя.",
  "triggers.nameHint": "Буквы, цифры, точки, дефисы, подчёркивания.",
  "triggers.description": "Описание",
  "triggers.optional": "необязательно",
  "triggers.descriptionPlaceholder": "Для чего этот триггер",
  "triggers.firesWhen": "Срабатывает когда",
  "triggers.firesApp": "Открывается приложение",
  "triggers.firesText": "На экране появляется текст",
  "triggers.valueApp": "Пакет",
  "triggers.valueText": "Текст для отслеживания",
  "triggers.valueAppHint": "Скопируйте его на вкладке «Приложения» в панели устройства.",
  "triggers.valueTextHint": "Ищется по всему экрану без учёта регистра.",
  "triggers.thenRecord": "Затем записывать",
  "triggers.stopWindow": "Фиксированное окно",
  "triggers.stopOnExit": "Пока приложение открыто",
  "triggers.recordFor": "Записывать",
  "triggers.safetyCap": "Предохранитель",
  "triggers.window": "Окно",
  "triggers.durationHintCap": "Запись остановится здесь, даже если приложение не закроется.",
  "triggers.durationHint": "От {min} до {max} секунд.",
  "triggers.seconds": "секунд",
  "triggers.create": "Создать триггер",
  "triggers.save": "Сохранить изменения",
  "triggers.created": "Создан триггер {name}.",
  "triggers.saved": "Триггер {name} сохранён.",
  "triggers.duplicateA": "Триггер с названием",
  "triggers.duplicateB": "уже существует. Выберите другое название.",
  "triggers.errNameEmpty": "Дайте триггеру название.",
  "triggers.errNameLong": "Название — не длиннее {max} символов.",
  "triggers.errNameChars": "Только буквы, цифры, точки, дефисы и подчёркивания — без пробелов.",
  "triggers.errPackageEmpty": "Какой пакет должен отслеживать телефон?",
  "triggers.errTextEmpty": "Какой текст должен отслеживать телефон?",
  "triggers.errDurationInt": "Нужно целое число секунд.",
  "triggers.errDurationRange": "От {min} до {max} секунд.",
  "triggers.durationShort": "{n} с",
  "triggers.recOnExit": "Пока приложение открыто",
  "triggers.recOnExitCap": "Пока приложение открыто · до {n} с",
  "triggers.subjectApp": "приложение",
  "triggers.subjectText": "текст",
  "triggers.previewWhen": "Когда",
  "triggers.previewOpens": "открывается, телефон записывает",
  "triggers.previewOpensUntil": "открывается, телефон записывает до его закрытия, но не дольше",
  "triggers.previewAppears": "появляется на экране, телефон записывает",
  "triggers.previewMaxSuffix": ".",

  // Analyze
  "analyzes.title": "Анализ",
  "analyzes.setTitle": "Наборы анализа",
  "analyzes.setIntro":
    "Именованный набор признаков, которые должны быть у телефона — его язык, установленное приложение, страна. Условий может быть сколько угодно, и телефон совпадает с набором, только когда выполняются все. Каждое устройство на странице «Устройства» показывает ✓ рядом с каждым включённым набором, которому оно соответствует, и ✗ — если нет; выключенные наборы не проверяются вовсе.",
  "analyzes.namePlaceholder": "название набора (напр. us instagram phone)",
  "analyzes.removeCondition": "Удалить это условие",
  "analyzes.addCondition": "+ условие",
  "analyzes.addConditionTitle": "Добавить ещё условие — телефон совпадает, только когда выполняются все",
  "analyzes.create": "Создать",
  "analyzes.allConditionsNote": "Телефон совпадает, только когда выполняются все условия.",
  "analyzes.th.name": "Название",
  "analyzes.th.checks": "Условия",
  "analyzes.th.matching": "Совпадение",
  "analyzes.th.created": "Создан",
  "analyzes.matching": "Совпадает: {matching} из {total}",
  "analyzes.disabled": "выключен",
  "analyzes.toggleOffTitle": "Перестать проверять телефоны по этому набору",
  "analyzes.toggleOnTitle": "Проверять телефоны по этому набору",
  "analyzes.on": "вкл",
  "analyzes.off": "выкл",
  "analyzes.deleteConfirm": "Удалить набор анализа «{name}»?",
  "analyzes.empty": "Наборы анализа пока не заданы.",
  "analyzes.matchYes": "Совпадает",
  "analyzes.matchNo": "Не совпадает",

  // Settings
  "settings.title": "Настройки",
  "settings.signedIn": "Аккаунт",
  "settings.role": "роль: {role}",
  "settings.enrollmentKeys": "Ключи регистрации",
  "settings.enrollmentKeysHint":
    "Вшейте ключ в APK агента — и каждый телефон, на который установлена эта сборка, сам регистрируется и появляется в списке устройств: одна сборка на весь парк. Отзыв ключа останавливает новые регистрации; уже подключённые телефоны продолжают работать.",
  "settings.enrollmentKeyBuild":
    "Соберите APK с вшитым ключом, установите на каждый телефон и один раз откройте приложение:",
  "settings.enrollmentKeyNamePlaceholder": "название ключа (напр. fleet)",
  "settings.enrollmentKeyCapPlaceholder": "макс. телефонов (необязательно)",
  "settings.th.phones": "Телефонов",
  "settings.noEnrollmentKeys":
    "Ключей пока нет — создайте ключ, чтобы собрать APK, который регистрирует каждый телефон при установке.",
  "settings.apiKeys": "API-ключи",
  "settings.apiKeysHintA": "Используются",
  "settings.apiKeysHintB": "CLI и CI. Задайте переменной",
  "settings.apiKeysHintC": "значение ниже.",
  "settings.mintedNote": "Скопируйте сейчас — ключ показывается один раз и хранится только в виде хэша.",
  "settings.keyNamePlaceholder": "название ключа (напр. ci)",
  "settings.create": "Создать",
  "settings.th.name": "Название",
  "settings.th.created": "Создан",
  "settings.th.lastUsed": "Использован",
  "settings.revoked": "· отозван",
  "settings.keyLegacy": "· нельзя использовать повторно",
  "settings.never": "никогда",
  "settings.revoke": "Отозвать",
  "settings.noKeys": "Ключей пока нет.",
  "settings.secrets": "Секреты",
  "settings.secretsHintA": "Используются как",
  "settings.secretsHintB":
    "Расшифровываются на воркере при запуске и никогда не возвращаются сюда — в логе шага остаётся шаблон, а не значение.",
  "settings.valuePlaceholder": "значение",
  "settings.save": "Сохранить",
  "settings.delete": "Удалить",
  "settings.noneStored": "Пока ничего не сохранено.",
  "settings.pools": "Пулы",
  "settings.poolsHintA": "Прогоны нацелены на пул, а не на конкретные телефоны:",
  "settings.noPools": "Пулы не заданы.",
  "settings.channels": "Каналы уведомлений",
  "settings.channelsHint": "Доступы только на запись: они сохраняются, используются и больше никогда не показываются.",
  "settings.channelNamePlaceholder": "название канала",
  "settings.add": "Добавить",
  "settings.delivered": "доставлено ✓",
  "settings.failed": "ошибка: {error}",
  "settings.sendTest": "Отправить тест",
  "settings.removeTitle": "Убрать",
  "settings.subscribePlaceholder": "+ подписаться на событие…",
  "settings.noChannels": "Каналы не настроены.",
  "settings.disabled": " · выключен",

  // Device panel
  "panel.back": "Назад",
  "panel.home": "Домой",
  "panel.recents": "Недавние",
  "panel.enter": "Ввод",
  "panel.notifs": "Уведомл.",
  "panel.quick": "Шторка",
  "panel.volUp": "Гром +",
  "panel.volDown": "Гром −",
  "panel.swipeLeft": "Влево",
  "panel.swipeRight": "Вправо",
  "panel.swipeUp": "Вверх",
  "panel.swipeDown": "Вниз",
  "panel.swipeTitle": "Свайп {dir}",
  "panel.hudTitle":
    "Частота доставленных кадров · задержка до сервера · задержка последней команды через телефон · возраст картинки на экране (примерно)",
  "panel.lockTitle": "Выключить экран",
  "panel.unlockTitle": "Разбудить и снять блокировку",
  "panel.hidePanel": "Скрыть боковую панель",
  "panel.showPanel": "Показать боковую панель",
  "panel.rename": "Переименовать устройство",
  "panel.save": "Сохранить",
  "panel.cancel": "Отмена",
  "panel.foreground": "Активное приложение",
  "panel.streaming": "транслируется",
  "panel.stalled": "подтормаживает",
  "panel.reconnecting": "переподключение…",
  "panel.notConnected": "нет соединения",
  "panel.deviceRefused": "Устройство отклонило команду",
  "panel.screenAlt": "экран устройства",
  "panel.waitingFrame": "ждём первый кадр…",
  "panel.noFrameYet":
    "Соединение есть, но телефон ещё не прислал ни одного кадра. Его журнал на странице устройств покажет, что происходит.",
  "panel.captureNeedsConsent":
    "На Android {version} нет скриншотов через спецвозможности. Для захвата экрана нужно одно подтверждение на телефоне.",
  "panel.captureStopped": "Захват экрана остановлен на телефоне. Запросите его снова.",
  "panel.requestCapture": "Запросить захват экрана на телефоне",
  "panel.captureConsentHint":
    "Затем нажмите «Начать» на телефоне. Картинка появится здесь через несколько секунд.",
  "panel.captureNeedsAgentUpdate":
    "На телефоне старая сборка агента, которая не умеет захватывать экран на Android {version}. Установите актуальный APK агента и запросите захват экрана здесь.",
  "panel.captureAccessibilityOff":
    "Спецвозможности на телефоне выключены. Включите службу QA Agent в Настройки → Спецвозможности — картинка появится, как только она заработает.",
  "panel.captureScreenOff": "Экран телефона выключен.",
  "panel.wake": "Разбудить экран",
  "panel.capturePlatformError":
    "Телефон не может сделать снимок: {message}. Захват через проекцию может работать там, где встроенный скриншот не работает.",
  "panel.requestCaptureFallback": "Переключиться на захват с подтверждением",
  "panel.noStream": "нет потока",
  "panel.deviceOffline": "Телефон не подключён",
  "panel.recChip": "На этом телефоне активен триггер",
  "panel.typePlaceholder": "Текст для активного поля…",
  "panel.send": "Отправить",
  "panel.gestureHint": "Перетаскивание — свайп · колесо — флик · двойной клик — двойной тап",
  "panel.tabTrigger": "Триггер",
  "panel.tabApps": "Приложения",
  "panel.tabModules": "Модули",
  "panel.tabNote": "Заметка",
  "panel.noModules": "В сборке этого телефона нет модулей.",
  "panel.moduleState.ok": "работает",
  "panel.moduleState.needs_permission": "нужно разрешение",
  "panel.moduleState.failed": "ошибка",
  "panel.moduleRun": "Выполнить",
  "panel.moduleRunning": "Выполняем\u2026",
  "panel.moduleClose": "Закрыть",
  "panel.moduleNotOnDevice":
    "В сборке этого телефона нет модуля {module}. Включите его и установите новую сборку.",
  "panel.moduleOffline": "Телефон сейчас не на связи.",
  "panel.moduleFailed": "Модуль отказал: {message}",
  "panel.triggerHeading": "Сценарий-триггер",
  "panel.triggerIntro": "Телефон записывает сам, когда условие срабатывает, и затем сообщает серверу.",
  "panel.disarm": "Деактивировать",
  "panel.conditionUnavailable": "условие: (детали недоступны)",
  "panel.durationWindow": " · окно {n} с",
  "panel.condWhenPackage": "когда открывается {package}",
  "panel.condWhenText": "когда появляется «{text}»",
  "panel.noTriggerArmed": "На этом телефоне триггер не активен.",
  "panel.chooseTrigger": "Выберите триггер…",
  "panel.arm": "Активировать",
  "panel.noTriggersYet": "Триггеров пока нет — создайте на странице «Триггеры».",
  "panel.latestCapture": "Последняя запись",
  "panel.loadingShort": "загрузка…",
  "panel.loading": "Загрузка…",
  "panel.framesToMp4": "{n} кадров → mp4",
  "panel.noVideoYet": "Видео пока нет — появится, когда запись завершится.",
  "panel.appsHeading": "Приложения",
  "panel.refresh": "Обновить",
  "panel.appsIntro": "Приложения с домашнего экрана этого телефона. Кликните, чтобы открыть.",
  "panel.filterApps": "Фильтр по названию или пакету…",
  "panel.connectToLoad": "Подключитесь к устройству, чтобы загрузить его приложения.",
  "panel.noAppsFilter": "По этому фильтру ничего нет.",
  "panel.noApps": "Телефон не сообщил ни одного приложения с домашнего экрана.",
  "panel.noteHeading": "Заметка об устройстве",
  "panel.editNote": "Редактировать заметку",
  "panel.noNote": "Заметки пока нет — особенности стенда, данные SIM, кто брал телефон.",
  "panel.notePlaceholder": "напр. тестовая SIM API 34, капризный Wi-Fi, забирали из команды платежей…",

  // --- Админ-консоль ------------------------------------------------
  "admin.title": "Automation LTD — админка",
  "admin.supportsDesigns": "Поддерживает дизайн экрана (спека v1)",
  "admin.designsChip": "дизайн v{v}",
  "admin.rolloutWithDesign": "Из них {n} несут собственный экран клиента.",
  "admin.nav.tenants": "Клиенты",
  "admin.nav.releases": "Релизы агента",
  "admin.nav.admins": "Администраторы",
  "admin.nav.audit": "Аудит",
  "admin.signIn": "Вход в админ-консоль",
  "admin.tenants": "Клиенты",
  "admin.newTenant": "Новый клиент",
  "admin.search": "Поиск по названию или слагу",
  "admin.name": "Название",
  "admin.slug": "Слаг",
  "admin.role": "Роль",
  "admin.status.active": "активен",
  "admin.status.suspended": "приостановлен",
  "admin.userActive": "активен",
  "admin.userDisabled": "отключён",
  "admin.status": "Статус",
  "admin.expires": "Доступ",
  "admin.expiryLeft": "осталось {n} дн.",
  "admin.expiryOneDay": "остался 1 день",
  "admin.expiryToday": "заканчивается сегодня",
  "admin.expiryEnded": "закончился {date}",
  "admin.devices": "Телефоны",
  "admin.users": "Логины",
  "admin.lastSeen": "Последняя связь",
  "admin.storage": "Хранилище",
  "admin.noTenants": "Клиентов пока нет. Создайте первого.",
  "admin.create": "Создать клиента",
  "admin.creating": "Создаём…",
  "admin.cancel": "Отмена",
  "admin.close": "Закрыть",
  "admin.loginEmail": "Email для входа",
  "admin.loginEmailHint": "Если оставить пустым, сгенерируем из слага.",
  "admin.contactEmail": "Контактный email",
  "admin.devicesOnlineOfTotal": "{online} из {total} телефонов на связи",
  "admin.batchLabel": "Партия",
  "admin.deviceCap": "Лимит телефонов",
  "admin.notes": "Заметки",
  "admin.accessUntil": "Доступ до",
  "admin.preset.14d": "14 дней",
  "admin.preset.30d": "30 дней",
  "admin.preset.90d": "90 дней",
  "admin.preset.1y": "1 год",
  "admin.preset.none": "Без срока",
  "admin.credentials": "Учётные данные",
  "admin.credentialsOnce": "Показываются один раз. Скопируйте и передайте клиенту.",
  "admin.password": "Пароль",
  "admin.email": "Email",
  "admin.back": "К списку клиентов",
  "admin.extend": "Продлить",
  "admin.suspend": "Приостановить",
  "admin.resume": "Возобновить",
  "admin.consoleAccess": "Доступ к панели",
  "admin.consoleAccessHelp":
    "Закрывает панель, API и API-ключи этого клиента. Телефоны остаются подключёнными, поэтому после восстановления ничего не придётся переустанавливать.",
  "admin.consoleBlocked": "Панель закрыта",
  "admin.consoleBlockedSince": "Закрыта с {date}",
  "admin.consoleNoReason": "Причина не указана",
  "admin.consoleBlock": "Закрыть доступ к панели",
  "admin.consoleBlockConfirm": "Закрыть доступ",
  "admin.consoleRestore": "Восстановить доступ к панели",
  "admin.consoleReason": "Причина (необязательно)",
  "admin.consoleReasonHint": "Клиент увидит её при попытке войти",
  "admin.consoleAlreadyBlocked": "Панель этого клиента уже закрыл кто-то другой.",
  "admin.consoleNotBlocked": "Панель этого клиента уже открыта.",
  "admin.consoleColumn": "Панель",
  "admin.open": "Открыть",
  "admin.openConsole": "Открыть панель",
  "admin.openingConsole": "Открываем…",
  "admin.openConsoleHelp":
    "Открывает панель клиента в новой вкладке — под одним из его собственных логинов, без пароля. Запись об этом появится в активности ниже.",
  "admin.openConsoleSuspended": "Снимите приостановку аккаунта, прежде чем открывать его панель.",
  "admin.openConsoleExpired": "Продлите доступ клиенту, прежде чем открывать его панель.",
  "admin.openConsoleClosed": "Верните клиенту доступ к панели, прежде чем открывать её.",
  "admin.openConsoleNoLogin": "У этого клиента нет активного логина, под которым можно открыть панель.",
  "admin.openConsoleDisabledLogin": "Этот логин отключён. Включите его или откройте панель под другим.",
  "admin.openConsoleNotOpened":
    "Панель не открылась. Разрешите всплывающие окна для этого адреса — или обновите десктопное приложение, если вы в нём, — и попробуйте снова.",
  "admin.disconnect": "Переподключить телефоны",
  "admin.resetPassword": "Сбросить пароль",
  "admin.deactivate": "Отключить",
  "admin.activate": "Включить",
  "admin.addLogin": "Добавить логин",
  "admin.keys": "Ключи подключения",
  "admin.builds": "Сборки агента",
  "admin.registry": "Телефоны",
  "admin.auditTail": "Последние события",
  "admin.dangerZone": "Опасная зона",
  "admin.purge": "Удалить клиента полностью",
  "admin.purgeWarning": "Удаляет все записи и файлы этого клиента. Отменить нельзя.",
  "admin.purgeConfirm": "Введите {slug} для подтверждения",
  "admin.rollout": "Собрать для всех клиентов",
  "admin.rolloutQueued": "В очереди {n} сборок агента {version}. Через несколько секунд каждый клиент увидит её у себя.",
  "admin.rolloutSkipped": "Пропущены (приостановлены или истёк доступ): {slugs}",
  "admin.rolloutDesignSkipped":
    "Из них {n} ушли без экрана клиента: он использует модуль, которого нет в релизе или который выключен.",
  "admin.modules": "Модули",
  "admin.designsAffected":
    "Агент {version} теперь текущий. Эти экраны клиентов используют модуль, которого в нём нет — их следующая сборка уйдёт без экрана:",
  "admin.releases": "Релизы агента",
  "admin.version": "Версия",
  "admin.current": "Текущий",
  "admin.makeCurrent": "Сделать текущим",
  "admin.upload": "Загрузить релиз",
  "admin.uploading": "Загружаем…",
  "admin.uploadHint": "Неподписанный release-APK из `make agent-template`.",
  "admin.mapping": "R8-маппинг (mapping.txt)",
  "admin.mappingHint":
    "Без него стек-трейс из этого релиза не прочитать. Gradle кладёт файл рядом с APK.",
  "admin.mappingColumn": "Маппинг",
  "admin.mappingMissing": "нет маппинга",
  "admin.addMapping": "Добавить маппинг",
  "admin.noMappingStored":
    "Агент {version} загружен без mapping.txt, поэтому стек-трейсы из него не прочитать. Файл остался только на машине, где его собирали.",
  "admin.noReleases": "Релиз агента ещё не загружен. Пока его нет, клиенты не смогут собрать APK.",
  "admin.admins": "Платформенные администраторы",
  "admin.addAdmin": "Добавить администратора",
  "admin.lastLogin": "Последний вход",
  "admin.actor": "Кто",
  "admin.action": "Действие",
  "admin.when": "Когда",
  "admin.noAudit": "Событий пока нет.",
  "admin.never": "никогда",

  // --- конструктор экрана приложения (DESIGN §9.6) --------------------------
  "nav.design": "Дизайн приложения",
  "nav.modules": "Модули",
  "design.title": "Дизайн приложения",
  "design.intro":
    "Оформите экран, который открывает QA Agent. Выберите его при сборке APK.",
  "design.new": "Новый дизайн",
  "design.create": "Создать",
  "design.creating": "Создаём…",
  "design.cancel": "Отмена",
  "design.name": "Название",
  "design.empty": "Дизайнов пока нет.",
  "design.emptyHint":
    "Пока вы не выберете дизайн для сборки, телефон показывает встроенный экран: одна кнопка на чёрном.",
  "design.default": "По умолчанию",
  "design.open": "Открыть",
  "design.setDefault": "Сделать основным",
  "design.duplicate": "Дублировать",
  "design.delete": "Удалить",
  "design.confirmDelete": "Удалить насовсем",
  "design.updated": "Изменён {when}",
  "design.back": "К списку дизайнов",
  "design.save": "Сохранить",
  "design.saving": "Сохраняем…",
  "design.undo": "Отменить",
  "design.redo": "Вернуть",
  "design.buildApk": "Собрать APK",
  "design.more": "Ещё",
  "design.stateSaved": "Сохранено",
  "design.stateUnsaved": "Есть несохранённые правки",
  "design.stateIssues": "Ошибок: {n} — сохранение недоступно",
  "design.blocks": "Блоки",
  "design.addBlock": "Добавить блок",
  "design.paletteHint": "Нажмите, чтобы добавить, или перетащите на телефон.",
  "design.noBlocks": "Пока пусто — добавьте блок выше или перетащите картинку на телефон.",
  "design.emptyFrame": "Перетащите сюда картинку или добавьте блок",
  "design.dragHint": "Перетащите, чтобы поменять порядок, — или выберите строку и жмите ↑ и ↓",
  "design.zoom": "Масштаб",
  "design.zoomFit": "Вписать",
  "design.group.content": "Содержимое",
  "design.group.style": "Оформление",
  "design.group.size": "Размер",
  "design.group.background": "Фон",
  "design.group.layout": "Раскладка",
  "design.stackHint":
    "Блоки идут сверху вниз. Перетащите, чтобы поменять порядок; выравнивание, «Во всю ширину» и блок «Отступ» ставят блок на место; где стоит весь столбец — в панели «Экран».",
  "design.remove": "Удалить",
  "design.theme": "Экран",
  "design.screenHint": "Фон и отступы",
  "design.previewNote":
    "Превью приблизительное: шрифты и переносы у телефонов немного отличаются, а размер текста следует настройкам телефона.",
  "design.issues": "Исправьте перед сохранением",
  "design.warnings": "Стоит знать",
  "design.moduleDisabledBanner":
    "Экран использует {modules}, а модуль выключен. Экран сохранится, но на телефоне это ничего не сделает, а сборку с ним мы не соберём.",
  "design.openModules": "Открыть «Модули»",
  "design.restorePrompt": "У этого дизайна остались несохранённые изменения.",
  "design.restore": "Восстановить изменения",
  "design.discardDraft": "Удалить их",
  "design.staleMessage":
    "Дизайн сохранили в другом месте. Перезагрузите, чтобы увидеть; ваш черновик сохранён.",
  "design.reload": "Перезагрузить",
  "design.nameIconNote":
    "Имя приложения и иконку пока изменить нельзя — любая сборка ставится как QaAgent.",
  "design.block.text": "Текст",
  "design.block.button": "Кнопка",
  "design.block.image": "Картинка",
  "design.block.spacer": "Отступ",
  "design.block.divider": "Разделитель",
  "design.block.status": "Панель состояния",
  "design.blockHint.text": "Строка или абзац.",
  "design.blockHint.button": "Делает одно действие из готового списка.",
  "design.blockHint.image": "Логотип или картинка — перетащите её на телефон.",
  "design.blockHint.spacer": "Пустое место между блоками.",
  "design.blockHint.divider": "Тонкая линия поперёк экрана.",
  "design.blockHint.status": "Живые строки: зарегистрирован ли телефон и работает ли он.",
  "design.text": "Текст",
  "design.label": "Надпись",
  "design.size": "Размер",
  "design.weight": "Начертание",
  "design.weight.regular": "Обычное",
  "design.weight.medium": "Среднее",
  "design.weight.bold": "Жирное",
  "design.font": "Шрифт",
  "design.font.sans": "Без засечек",
  "design.font.serif": "С засечками",
  "design.font.mono": "Моноширинный",
  "design.color": "Цвет",
  "design.mutedColor": "Цвет подписей",
  "design.textColor": "Цвет текста",
  "design.fill": "Заливка",
  "design.stroke": "Обводка",
  "design.align": "Выравнивание",
  "design.align.left": "Слева",
  "design.align.center": "По центру",
  "design.align.right": "Справа",
  "design.radius": "Скругление",
  "design.width": "Ширина",
  "design.height": "Высота",
  "design.thickness": "Толщина",
  "design.inset": "Отступ по краям",
  "design.fullWidth": "Во всю ширину",
  "design.buttonSize": "Высота",
  "design.buttonSize.sm": "Маленькая",
  "design.buttonSize.md": "Средняя",
  "design.buttonSize.lg": "Большая",
  "design.variant": "Стиль",
  "design.variant.filled": "С заливкой",
  "design.variant.outlined": "С обводкой",
  "design.variant.text": "Только текст",
  "design.action": "Что делает",
  "design.actionGroup.core": "Приложение",
  "design.actionGroup.off": "Недоступно",
  "design.moduleAsks": "\ud83d\udd12 При первом нажатии запросит разрешение: {permission}.",
  "design.moduleActionUnknown":
    "Кнопка запускает действие модуля {module}, которого нет в этом релизе.",
  "design.moduleBlockUnknown":
    "Экран показывает блок модуля {module}, которого нет в этом релизе.",
  "design.moduleBlockFlex":
    "Занимает весь экран; остальные блоки остаются над ним или под ним.",
  "design.paramRequired": "обязательно",
  "design.action.enable_accessibility": "Включить спец. возможности",
  "design.action.ignore_battery_optimization": "Работать в фоне",
  "design.action.allow_screen_capture": "Разрешить захват экрана",
  "design.action.open_url": "Открыть ссылку",
  "design.action.open_app_settings": "Открыть настройки приложения",
  "design.action.copy_device_id": "Скопировать идентификатор",
  "design.action.forget_enrollment": "Выйти из аккаунта",
  "design.actionHint.enable_accessibility":
    "Открывает системный экран, где включается служба QA. Такая кнопка нужна в каждом дизайне.",
  "design.actionHint.ignore_battery_optimization":
    "Просит Android не усыплять агента — это разница между телефоном на связи и тем, что отвалился через час.",
  "design.actionHint.allow_screen_capture":
    "Запрашивает согласие на захват экрана. Нужно на Android 9 и 10 и на части телефонов новее.",
  "design.actionHint.open_url": "Открывает https-ссылку в браузере телефона.",
  "design.actionHint.open_app_settings":
    "Открывает страницу приложения в настройках — там Android 13+ прячет разблокировку ограниченных настроек.",
  "design.actionHint.copy_device_id":
    "Копирует идентификатор телефона в буфер обмена. Первое, что спрашивает поддержка.",
  "design.actionHint.forget_enrollment":
    "Сначала спросит, потом уберёт телефон из вашего аккаунта. При следующем запуске он зарегистрируется заново.",
  "design.url": "Ссылка",
  "design.alt": "Описание (для экранных дикторов)",
  "design.spacer.flex": "Занять оставшееся место",
  "design.spacer.hint": "Гибкий отступ прижимает всё, что после него, к низу экрана.",
  "design.status.hint":
    "Реальные значения с телефона. Так человек с телефоном в руках видит, что всё работает.",
  "design.rows": "Строки",
  "design.row.enrollment": "Регистрация",
  "design.row.accessibility": "Служба QA",
  "design.row.capture": "Захват экрана",
  "design.row.version": "Версия агента",
  "design.row.tenant": "Аккаунт",
  "design.background": "Фон",
  "design.background.solid": "Один цвет",
  "design.background.gradient": "Градиент",
  "design.background.image": "Картинка",
  "design.gradientStop": "Цвет {n}",
  "design.addStop": "Добавить цвет",
  "design.removeStop": "Убрать цвет",
  "design.angle": "Направление",
  "design.scale": "Заполнение",
  "design.scale.cover": "Заполнить экран",
  "design.scale.contain": "Вписать целиком",
  "design.overlay": "Затемнить картинку",
  "design.overlayColor": "Затемнение",
  "design.statusBarIcons": "Иконки статус-бара",
  "design.statusBarIcons.light": "Светлые",
  "design.statusBarIcons.dark": "Тёмные",
  "design.padding": "Поля экрана",
  "design.gap": "Промежуток между блоками",
  "design.verticalAlign": "Положение по вертикали",
  "design.verticalAlign.top": "Сверху",
  "design.verticalAlign.center": "По центру",
  "design.verticalAlign.bottom": "Снизу",
  "design.noImage": "Нет",
  "design.uploadImage": "Загрузить картинку",
  "design.uploading": "Загружаем…",
  "design.uploadHint": "PNG, JPEG или WebP. Занято {used} из {max}; можно перетащить файл сюда.",
  "design.assetsFull": "Все {max} слотов для картинок заняты.",
  "design.removeImage": "Удалить картинку",
  "design.dropImage": "Отпустите, чтобы добавить картинку",
  "design.notAnImage": "{name} — не PNG, JPEG или WebP.",
  "design.imageTooLarge": "{name} больше {mb} МБ.",
  "design.blocksFull": "В дизайне уже все {max} блоков.",

  // --- Модули (MODULES §8.7) ----------------------------------------------
  "modules.title": "Модули",
  "modules.intro":
    "Дополнения, которые текущий релиз агента умеет встроить в ваше приложение. Включение меняет то, что попадёт в следующую сборку APK.",
  "modules.emptyRelease": "В этом релизе модулей нет.",
  "modules.on": "Вкл",
  "modules.off": "Выкл",
  "modules.toggleAria": "Включить или выключить {module}",
  "modules.adds":
    "Добавляет действий: {actions}, значений: {values}, блоков: {blocks}, команд: {commands}",
  "modules.actions": "Действия",
  "modules.values": "Значения",
  "modules.blocks": "Блоки",
  "modules.commands": "Команды",
  "modules.permissionOptional": "необязательно",
  "modules.permissionOptionalHint":
    "Модуль работает и без него — телефон спросит, только когда это нужно странице.",
  "modules.size": "около {kb} КБ",
  "modules.needsAgent": "Нужен агент {version} или новее — текущий релиз старше.",
  "modules.usedBy": "Используют экраны:",
  "modules.usedByWhileOff":
    "пока модуль выключен, сборку с таким экраном мы не соберём.",
  "modules.requires": "Сначала включите {module} — этот модуль без него не работает.",
  "modules.apkNote": "На уже установленные телефоны нужно поставить новый APK.",

  // --- Console chrome and the sign-in screen ------------------------------
  "app.name": "Automation LTD",
  "app.menu": "Открыть меню",
  "app.closeMenu": "Закрыть меню",
  "nav.group.fleet": "Парк",
  "nav.group.rollout": "Раскатка",
  "nav.group.account": "Аккаунт",

  "login.title": "Вход",
  "login.subtitle": "Введите email и пароль, которые мы вам выслали.",
  "login.emailPlaceholder": "you@company.com",

  "admin.brandSub": "Админка платформы",
  "admin.nav.group.customers": "Клиенты",
  "admin.nav.group.platform": "Платформа",

  // --- Приложение для компьютера (DESKTOP §2.4) ---------------------------
  "loading.desktop": "приложение для компьютера",
  "desktop.versionLine": "Версия {version} · выпущена {date}",
  "desktop.versionOnly": "Версия {version}",
  "desktop.downloadMacArm": "Скачать для Mac (Apple silicon)",
  "desktop.downloadMacIntel": "Скачать для Mac (Intel)",
  "desktop.downloadWindows": "Скачать для Windows",
  "desktop.fileVersion": "версия {version}",
  "desktop.whichMac":
    "Не знаете, какой у вас Mac? Меню Apple → «Об этом Mac» покажет, какой внутри процессор.",
  "desktop.noInstallers": "В этом выпуске пока нечего скачивать.",

  "settings.desktopApp": "Приложение для компьютера",
  "settings.desktopHint":
    "Панель в отдельном окне на вашем компьютере. Она собирает APK агента здесь, а не на наших серверах — именно это нужно кнопке «Собрать на этом компьютере» на странице «APK агента» — и обновляется сама.",
  "settings.desktopNone": "Версию для компьютера мы ещё не выпустили.",
  "settings.desktopRunning": "Вы работаете в приложении, версия {version}.",
  "settings.desktopUpdate":
    "Доступна версия {version} — приложение предложит её в меню Server → Check for Updates…",

  "admin.desktop": "Приложения для компьютера",
  "admin.nav.desktop": "Приложения для ПК",
  "admin.desktopAdminApp": "Automation LTD Admin",
  "admin.desktopAdminAppHint":
    "Эта админка в собственном окне. Моста для сборки APK в нём нет — оно ничего не собирает.",
  "admin.desktopCustomerApp": "Automation LTD (приложение клиента)",
  "admin.desktopCustomerAppHint":
    "То, что ставит себе клиент: его панель и локальная сборка APK.",
  "admin.desktopCustomerFinds":
    "Клиенты скачивают его сами — в своей панели, в разделе «Настройки → Приложение для компьютера».",
  "admin.desktopNotPublished": "Ещё не опубликовано.",
  "admin.desktopPublishA": "Новая версия публикуется командой",
  "admin.desktopPublishB": "после того как поднят номер версии в",
  "admin.desktopPublishC":
    "— установленные приложения предложат обновление при следующей проверке.",
// --- Ready builds: the library of finished APKs -----------------------------
"nav.readyApks": "Готовые APK",
"readyBuilds.title": "Готовые APK",
"readyBuilds.intro":
  "Готовые подписанные сборки, которые любой сотрудник консоли может ставить как есть. Перетащите .apk ниже — он попадёт в библиотеку для всех; отдельную сборку можно закрепить за одним входом, пока она не готова для всей команды.",
"readyBuilds.dropHere": "Перетащите .apk сюда или",
"readyBuilds.pickFile": "выберите файл",
"readyBuilds.notApk": "«{name}» — не .apk файл.",
"readyBuilds.notesPlaceholder": "Заметки к сборке (что это, что изменилось…)",
"readyBuilds.visibleHint": "Загруженные сборки видны всем, у кого есть доступ к этой консоли.",
"readyBuilds.upload": "Добавить в библиотеку",
"readyBuilds.cancel": "Отмена",
"readyBuilds.save": "Сохранить",
"readyBuilds.empty": "В библиотеке пока нет сборок — добавьте первую выше.",
"readyBuilds.colBuild": "Сборка",
"readyBuilds.colNotes": "Заметки",
"readyBuilds.colVisible": "Видно",
"readyBuilds.colAdded": "Добавлено",
"readyBuilds.editNotes": "Изменить",
"readyBuilds.visibleAll": "Всем",
"readyBuilds.visibleOne": "Только {email} — открыть всем?",
"readyBuilds.download": "Скачать",
"readyBuilds.copyLink": "Скопировать ссылку",
"readyBuilds.copied": "Скопировано",
"readyBuilds.linkHint": "По этой ссылке APK скачает любой — вход не нужен.",
"readyBuilds.delete": "Удалить",
"readyBuilds.confirmDelete": "Удалить окончательно?",
};
